import {
  Box,
  Icon, IconName,
  Text,
} from '@usealloy/component-library';
import React from 'react';

import { NODE_HEIGHT_XL } from 'flow/service/graph';
import type { RiskCalculationNode as IRiskCalculationNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';
import { StyledLabelText, StyledRiskScoringIconContainer } from './styles';

function RiskCalculationNode(props: WorkflowNodeProps<IRiskCalculationNode>) {
  const { id, type, data: { label } } = props;

  const multilineLabel = (
    <Box direction="column" alignItems="flex-start" width="116px">
      <Text size={1} style={{ color: 'var(--cl-text-muted)' }}>
        Final Calculation
      </Text>
      <StyledLabelText>
        {label}
      </StyledLabelText>
    </Box>
  );

  return (
    <BaseNode
      icon={(
        <StyledRiskScoringIconContainer alignItems="center" justifyContent="center">
          <Icon icon={IconName.Bookmark} size="large" color="var(--cl-gray-000)" />
        </StyledRiskScoringIconContainer>
      )}
      id={id}
      label={multilineLabel}
      style={{
        borderRadius: 'var(--cl-radius-3)',
        border: '1px solid var(--cl-juicyBlue-100)',
        height: `${NODE_HEIGHT_XL}px`,
        padding: 'var(--cl-space-1) var(--cl-space-2)',
      }}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-gray-000)',
        highlighted: {
          backgroundColor: 'var(--cl-gray-000)',
        },
        hovered: {
          backgroundColor: 'var(--cl-gray-100)',
        },
      }}
      menuTriggerStyle={{ height: 24, width: 24, borderRadius: 'var(--cl-radius-1)' }}
      type={type}
    />
  );
}

export default React.memo(RiskCalculationNode);

